import { render } from "./RewardPage.vue?vue&type=template&id=0c47f180&scoped=true"
const script = {}

import "./RewardPage.vue?vue&type=style&index=0&id=0c47f180&scoped=true&lang=css"

import exportComponent from "/home/mitch/frontend/demoenv/demo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c47f180"]])

export default __exports__